<template>
  <BaseDialog centered contentClass="documents-downloaded" ref="dialog" :show-actions="true" @closeModal="closeDialog">
    <template slot="title">{{ $t('aloha-extension.documents-downloaded.title') }}</template>
    <template slot="content">
      <div class="documents-downloaded-dialog">
        <p v-if="opportunityName" class="documents-downloaded-dialog__title">{{ opportunityName }}</p>
        <div v-if="downloadedDocuments.length > 0" class="documents-downloaded-dialog__section">
          <h3 class="documents-downloaded-dialog__subtitle">
            {{
              $tc('aloha-extension.documents-downloaded.downloaded', downloadedDocuments.length, {
                count: downloadedDocuments.length,
              })
            }}
          </h3>
          <ul class="documents-downloaded-dialog__list">
            <li v-for="doc in downloadedDocuments" :key="doc.documentId" class="documents-downloaded-dialog__item">
              <BaseIcon name="check-circle" class="documents-downloaded-dialog__icon is-success" />
              <span>{{ doc.title }}</span>
            </li>
          </ul>
        </div>
        <div v-if="failedDocuments.length > 0" class="documents-downloaded-dialog__section">
          <h3 class="documents-downloaded-dialog__subtitle is-error">
            {{
              $tc('aloha-extension.documents-downloaded.failed', failedDocuments.length, {
                count: failedDocuments.length,
              })
            }}
          </h3>
          <ul class="documents-downloaded-dialog__list">
            <li v-for="doc in failedDocuments" :key="doc.documentId" class="documents-downloaded-dialog__item">
              <BaseIcon name="alert-circle" class="documents-downloaded-dialog__icon is-error" />
              <div class="documents-downloaded-dialog__item-content">
                <span class="documents-downloaded-dialog__doc-title">{{ doc.title }}</span>
                <span class="documents-downloaded-dialog__reason">
                  {{ $t(`aloha-extension.documents-downloaded.reasons.${doc.reason}`) }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template slot="actions">
      <div class="documents-downloaded-dialog__actions">
        <BaseButton @click.native="closeDialog">{{ $t('actions.close') }}</BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'DocumentsDownloadedDialog',
  components: {
    BaseButton,
    BaseDialog,
    BaseIcon,
  },
  data() {
    return {
      opportunityName: '',
      downloadedDocuments: [],
      failedDocuments: [],
    };
  },
  methods: {
    openDialog({ opportunityName, downloadedDocuments, failedDocuments }) {
      this.opportunityName = opportunityName;
      this.downloadedDocuments = downloadedDocuments;
      this.failedDocuments = failedDocuments;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__documents-downloaded {
  height: auto;
  max-height: 80vh !important;
  width: 50%;
  min-width: 400px;
  max-width: 600px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    padding: 0;
  }

  .base-dialog__actions {
    padding: 16px 32px;
    background: transparent;
  }
}

.documents-downloaded-dialog {
  padding: 0 32px 16px;

  &__title {
    font-size: $font-size-xbigger;
    font-weight: 700;
    color: $color-normal;
    margin: 0 0 16px;
  }

  &__section {
    margin-bottom: 16px;
  }

  &__subtitle {
    font-family: $font-family-raleway;
    font-size: $font-size-small;
    font-weight: 700;
    color: $color-normal;
    margin-bottom: 8px;

    &.is-error {
      color: $color-error;
    }
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 0;
    border-bottom: 1px solid $color-border;
    font-size: $font-size-small;

    &:last-child {
      border-bottom: none;
    }
  }

  &__icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin-top: 2px;

    &.is-success {
      color: $color-success;
    }

    &.is-error {
      color: $color-error;
    }
  }

  &__item-content {
    display: flex;
    flex-direction: column;
  }

  &__doc-title {
    font-weight: 600;
  }

  &__reason {
    font-size: $font-size-xsmall;
    color: $color-error;
    margin-top: 2px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
